import { createPortal } from "react-dom";
import { TgEmoji } from "@/components/TgEmoji";
import { PopupCloseButton } from "@/components/PopupClose";

/**
 * Попап після ПОКУПКИ заморозки (owner 2026-07-22): дні нараховано на баланс
 * (підписка НЕ заморожується автоматично). Стиль 1:1 з
 * SubscriptionActivatedModal: центрований, rounded-3xl, анімований емодзі
 * (⏳ — час на паузі) + заголовок + опис.
 */
export function FreezeCreditedModal({
  daysAdded,
  balance,
  onClose,
}: {
  daysAdded: number;
  balance: number;
  onClose: () => void;
}) {
  const dw = (n: number) => (n === 1 ? "день" : n < 5 ? "дні" : "днів");
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-xs bg-surface rounded-3xl p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <PopupCloseButton onClose={onClose} />
        <div className="text-center mb-1">
          <div className="mb-2 flex justify-center">
            <TgEmoji char="⏳" size={48} />
          </div>
          <div className="font-display text-[1.125rem] font-bold text-ink leading-tight mb-1.5">
            Заморозку нараховано!
          </div>
          {/* Один компактний рядок — 1:1 зі стилем попапа активації підписки
              (owner 2026-07-22: «не переповнювати текстом»). */}
          <div className="text-[0.8125rem] text-ink-dim leading-relaxed">
            +{daysAdded} {dw(daysAdded)} · на балансі {balance} дн.
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
